module.exports = __webpack_public_path__ + "static/media/aw.1eb0d2cd.svg";